import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../authentication/services/auth.guard.service';
import { PendingPostTranslationsFilterComponent } from './components/scripts/pendingPostTranslationsFilter.component';
import { PostTranslationComponent } from './components/scripts/postTranslation.component';


const postTranslationsRoutes: Routes = [
 {
    path: 'postTranslations', component: PendingPostTranslationsFilterComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'PostTranslationManager', 'PostTranslationUser']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: 'filter',
            component: PendingPostTranslationsFilterComponent,
            data: { preload: true }
          }
        ]
      }
    ]
  },
  {
    path: 'postTranslations/translate/:OriginalPostId',
    component: PostTranslationComponent,
    data: {
      roles: ['Admin', 'PostTranslationManager', 'PostTranslationUser']
    },
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(postTranslationsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class PostTranslationsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/postTranslations/postTranslations-routing.module.ts